

import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Modal from "react-bootstrap/Modal";
import * as singleActions from '../../store/actions/single';
import Table from "react-bootstrap/Table";
import * as eventActions from '../../store/actions/events';

class SchoolModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            preview: ''
        }
    }
    hideModal = () => {
        this.props.handleModal(false)
    }

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(props) {
        if (this.props.data._id !== props.data._id) {
            this.init();
        }
    }

    init = () => {
        // If we came from the event dash (default/no source), the id in the url is the event ID, and we were passed the school id
        // If we came from a school page, the opposite is true
        const params = {
            id: this.props.source === "schools" ? this.props.data._id : this.props.match.params.id,
            school: this.props.source === "schools" ? this.props.match.params.id : this.props.data._id
        }
        this.props.get(params, this.props.auth.token._id);
    }


    render() {
        // If we came from schools view the header will be the event name, if we came from the even dash the header will be the school name
        const headerText = this.props.source === "schools" ? 
            this.props.data?.name ?? '' :
            this.props.events?.organizerSchool?.name ?? ''

        if (this.props.events.organizerSchool) {
            if ((this.props.events.organizerSchool._id === this.props.data._id) || this.props.source === "schools") {
                return (
                    <div className={this.props.user.user.theme}>
                        <Modal centered size={'lg'} className={`theme-${this.props.user.user.theme}`} show={this.props.show} onHide={e => this.props.hideModal(false)}>
                            <Modal.Body>
                                <div className={"spacer"} />
                                <h5>
                                    {headerText}
                                </h5>
                                <div className={"spacer"} />
                                <Table responsive>
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Competitions</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {this.props.events.schoolEntries.map((entry, i) => {
                                        return entry.sections.map((section, o) => {
                                            if (section.competitions.length > 0) {
                                                return (
                                                    <tr>
                                                        <td>{section.profile.name} {section.profile.lname}</td>
                                                        <td>{section.competitions.map((comp, compi) => {
                                                            return comp.name;
                                                        }).join(', ')}</td>
                                                    </tr>
                                                )
                                            } else {
                                                return null;
                                            }

                                        })

                                    })}


                                    </tbody>
                                </Table>
                            </Modal.Body>
                        </Modal>
                    </div>
                )
            } else{
                return null
            }
        } else {
            return null
        }

    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    user: state.user,
    single: state.single,
    events: state.events
});

const mapDispatchToProps = dispatch => ({
    post: (uri, item, token) => {
        dispatch(singleActions.post(uri, item, token));
    },
    postFile: (uri, fd, token) => {
        dispatch(singleActions.postFile(uri, fd, token));
    },
    patch: (uri, id, item, token) => {
        dispatch(singleActions.patch(uri, id, item, token));
    },
    get: (query, token) => {
        dispatch(eventActions.getOrganizerSchool(query, token));
    }
});

const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(SchoolModal));

class SchoolModalContainer extends React.Component {
    render() {
        return (
            <div>
                <Connected {...this.props} />
            </div>
        )
    }
}

export default SchoolModalContainer;
